import React from "react";

const Header = () => {
  return (
    <header className='flex justify-center'>
      <h1 className='pt-12 text-4xl lg:text-5xl lg:leading-normal  text-center font-bold font uppercase tracking-wide border-b-2 w-max leading-relaxed'>Welcome to Crypto Tracker</h1>
    </header>
  );
};

export default Header;
